import React from "react";

import TopHeader from "components/the-buzz-theme/header/top-header";
import { Header } from "components/the-buzz-theme/header/header";
import { Footer } from "components/the-buzz-theme/footer/footer";
import { SVGList } from "components/the-buzz-theme/svg-list/svg-list";
import { Main } from "components/the-buzz-theme/main/main";

export type PageProps = {
  tags?:
    | undefined
    | {
        name: string;
        count: number;
        slug: string;
      }[];
};

export default function Page(props: React.PropsWithChildren<PageProps>) {
  return (
    <>
      <SVGList />
      <TopHeader />
      <Header tags={props.tags} />
      <Main>{props.children}</Main>
      <Footer />
    </>
  );
}
